var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Pane, Accordion, IconButton, AccordionSet, Icon, Checkbox, Row, Col, } from "@folio/stripes/components";
import { StripesConnectedSource, } from "@folio/stripes/smart-components";
import { RecekTextField, RecekDatepicker, RecekSelect, RecekSelection, } from "../../components/inputs";
import TableComponent from "../../components/TableComponent";
import AuditLogDetail from "./AuditLogDetail";
import { fetchAuditLogs } from "../../api/auditService";
import { fetchUserById, fetchUserOptions } from "../../api/usersService";
import { usePickerOptions } from "../../hooks/usePickerOptions";
import { PickerHint } from "../../components/PickerHint";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { formatDateTime } from "../../utils/dateTimeUtil";
import { usePageSize } from "../../hooks/usePageSize";
import { AUDIT_DEFAULT_WINDOW_DAYS, AUDIT_ENTITY_ACTIONS, AUDIT_ENTITY_NAMES, getAuditActionLabel, formatAuditRecordCount, getAuditEntityLabel, isDefaultWindowApplied, parseAuditLogFilters, } from "../../utils/auditLogUtils";
var AuditLogsList = function () {
    var _a;
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _b = useState({
        entityName: "",
        entityAction: null,
        userId: "",
        entityId: null,
        createDateFrom: null,
    }), filters = _b[0], setFilters = _b[1];
    var _c = useState(0), pageOffset = _c[0], setPageOffset = _c[1];
    var _d = useState(0), totalRecords = _d[0], setTotalRecords = _d[1];
    var _e = useState(true), totalRecordsExact = _e[0], setTotalRecordsExact = _e[1];
    var _f = usePageSize(function () {
        return setPageOffset(0);
    }), pageSize = _f.pageSize, handlePageSizeChange = _f.handlePageSizeChange;
    var _g = useState(true), filterPaneIsVisible = _g[0], setFilterPaneIsVisible = _g[1];
    var _h = useState(null), selectedAuditLog = _h[0], setSelectedAuditLog = _h[1];
    var _j = useState(null), tempEntity = _j[0], setTempEntity = _j[1];
    var _k = useState(""), tempId = _k[0], setTempId = _k[1];
    var _l = useState(null), tempAction = _l[0], setTempAction = _l[1];
    var _m = useState(null), tempUser = _m[0], setTempUser = _m[1];
    var _o = useState(null), tempCreateDateFrom = _o[0], setTempCreateDateFrom = _o[1];
    var _p = useState(null), tempCreateTimeFrom = _p[0], setTempCreateTimeFrom = _p[1];
    var _q = useState(false), isCheckboxChecked = _q[0], setIsCheckboxChecked = _q[1];
    var _r = useState({
        users: [],
        totalRecords: 0,
    }), users = _r[0], setUsers = _r[1];
    var _s = useState(""), selectedUser = _s[0], setSelectedUser = _s[1];
    var _t = useState(""), userQuery = _t[0], setUserQuery = _t[1];
    // DB-876: debounced, abortable search-as-you-type; a full page asks to refine the search
    var _u = usePickerOptions(userQuery, function (term, signal) {
        return fetchUserOptions(ky, term, signal).then(function (page) { var _a; return (_a = page.users) !== null && _a !== void 0 ? _a : []; });
    }), foundUsers = _u.options, userLoading = _u.loading, usersTruncated = _u.truncated;
    // while nothing is typed, the user preselected from the URL is the only option
    var userOptions = userQuery ? foundUsers : users.users;
    var handleUserInput = function (inputValue) {
        setUserQuery(inputValue);
    };
    var handleUserSelection = function (selectedValue) {
        setSelectedUser(selectedValue);
        setTempUser(selectedValue);
    };
    useEffect(function () {
        var updatedFilters = parseAuditLogFilters(location.search);
        // preload the user filter from the URL; the entity id is not a user id
        var userIdParam = updatedFilters.userId;
        if (userIdParam) {
            var fetchUser = function () { return __awaiter(void 0, void 0, void 0, function () {
                var fetchedUser, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, fetchUserById(ky, userIdParam)];
                        case 1:
                            fetchedUser = _a.sent();
                            setUsers({ users: [fetchedUser], totalRecords: 1 });
                            setSelectedUser(userIdParam);
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error("Error fetching users:", error_1);
                            setUsers({ users: [], totalRecords: 0 });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            fetchUser();
        }
        setFilters(updatedFilters);
        // seed the form from the URL too, so "Aplikovat" keeps the filters that are shown
        setTempEntity(updatedFilters.entityName || null);
        setTempId(updatedFilters.entityId || "");
        setTempAction(updatedFilters.entityAction || null);
        setTempUser(updatedFilters.userId || null);
        setTempCreateDateFrom(updatedFilters.createDateFrom);
        setTempCreateTimeFrom(updatedFilters.createTimeFrom);
    }, [location.search]);
    var updateUrlWithFilters = function () {
        var params = new URLSearchParams();
        if (tempEntity)
            params.set("entityName", tempEntity);
        if (tempId)
            params.set("entityId", tempId);
        if (tempAction)
            params.set("entityAction", tempAction);
        if (tempUser)
            params.set("userId", tempUser);
        if (tempCreateDateFrom)
            params.set("createDateFrom", tempCreateDateFrom);
        if (tempCreateTimeFrom)
            params.set("createTimeFrom", tempCreateTimeFrom);
        history.push({ search: params.toString() });
    };
    var handleClearFilters = function () {
        setPageOffset(0);
        setFilters({
            entityName: "",
            entityAction: null,
            userId: "",
            entityId: null,
            createDateFrom: null,
        });
        setTempEntity("");
        setTempId("");
        setTempAction(null);
        setTempUser(null);
        setTempCreateDateFrom(null);
        setSelectedUser("");
        history.push({ search: "" });
    };
    var isAnyFilterActive = function () {
        return Object.values(filters).some(function (value) { return value; }) || isCheckboxChecked;
    };
    var _v = useQuery(["audit-logs", filters, pageOffset, pageSize], function () {
        return fetchAuditLogs(ky, __assign(__assign({}, filters), { offset: pageOffset, limit: pageSize }));
    }, {
        enabled: isAnyFilterActive(),
        keepPreviousData: true,
        onSuccess: function (data) {
            setTotalRecords(data.totalRecords);
            setTotalRecordsExact(data.totalRecordsExact);
        },
    }), data = _v.data, isLoading = _v.isLoading, isError = _v.isError, isFetched = _v.isFetched;
    var auditLogsData = (_a = data === null || data === void 0 ? void 0 : data.auditLogs) !== null && _a !== void 0 ? _a : [];
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var allOption = {
        label: formatMessage({ id: "ui-br-users.auditLogs.select.option.all" }),
        value: "",
    };
    var entityTypeOptions = __spreadArray([
        allOption
    ], AUDIT_ENTITY_NAMES.map(function (name) { return ({
        label: getAuditEntityLabel(name, formatMessage),
        value: name,
    }); }).sort(function (a, b) { return a.label.localeCompare(b.label, "cs"); }), true);
    var actionOptions = __spreadArray([
        allOption
    ], AUDIT_ENTITY_ACTIONS.map(function (action) { return ({
        label: getAuditActionLabel(action, formatMessage),
        value: action,
    }); }), true);
    var columns = [
        {
            name: formatMessage({ id: "ui-br-users.auditLogs.column.entity" }),
            key: "entityName",
            cellRenderer: function (item) {
                return getAuditEntityLabel(item.entityName, formatMessage);
            },
            clickable: true,
            onClick: function (item) {
                setSelectedAuditLog(item);
            },
        },
        {
            name: formatMessage({ id: "ui-br-users.auditLogs.column.user" }),
            key: "user",
            cellRenderer: function (item) {
                return item.user ? "".concat(item.user.firstName, ", ").concat(item.user.lastName) : "";
            },
        },
        {
            name: formatMessage({ id: "ui-br-users.auditLogs.column.action" }),
            key: "entityAction",
            cellRenderer: function (item) {
                return getAuditActionLabel(item.entityAction, formatMessage);
            },
        },
        {
            name: formatMessage({ id: "ui-br-users.auditLogs.column.entityId" }),
            key: "entityId",
            cellRenderer: function (item) { return item.entityId || "—"; },
        },
        {
            name: formatMessage({ id: "ui-br-users.auditLogs.column.time" }),
            key: "createTime",
            cellRenderer: function (item) {
                return item.createTime ? formatDateTime(item.createTime) : "";
            },
        },
    ];
    var source = new StripesConnectedSource({}, ky);
    source.update = function () { };
    source.records = function () { return auditLogsData; };
    source.resultCount = function () { return totalRecords; };
    source.totalCount = function () { return totalRecords; };
    source.pending = function () { return isLoading; };
    source.loaded = function () { return isFetched; };
    source.failure = function () { return (isError ? { message: "Error loading data" } : null); };
    source.failureMessage = function () { return "Error loading data"; };
    source.successfulMutations = function () { return []; };
    source.fetchMore = function () { return setPageOffset; };
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: "Filtrov\u00E1ni", lastMenu: React.createElement(IconButton, { icon: "caret-left", onClick: toggleFilterPane, "aria-label": filterPaneIsVisible ? "Hide filters" : "Show filters", style: { marginLeft: "auto" } }) },
            React.createElement(Button, { buttonStyle: "none", disabled: !isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                React.createElement(Icon, { icon: "times-circle-solid" }, "Resetovat v\u0161echno")),
            React.createElement(AccordionSet, null,
                React.createElement("form", { onSubmit: function (event) {
                        event.preventDefault();
                        setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { entityName: tempEntity, entityId: tempId, entityAction: tempAction, userId: tempUser || "", createDateFrom: tempCreateDateFrom })); });
                        setPageOffset(0);
                        updateUrlWithFilters();
                    } },
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-users.auditLogsList.accordion.label.filters",
                        }), separator: false },
                        React.createElement(Checkbox, { key: "fetch-all", label: formatMessage({
                                id: "ui-br-users.auditLogsList.checkbox.label.all",
                            }), checked: isCheckboxChecked, onChange: function (e) {
                                setIsCheckboxChecked(!isCheckboxChecked);
                                var isChecked = e.target.checked;
                                if (isChecked) {
                                    var clearedFilters = {
                                        entityName: "",
                                        entityAction: null,
                                        userId: "",
                                        entityId: null,
                                        createDateFrom: null,
                                        createTimeFrom: null,
                                    };
                                    setFilters(clearedFilters);
                                    setTempEntity("");
                                    setTempId("");
                                    setTempAction(null);
                                    setTempUser(null);
                                    setTempCreateDateFrom(null);
                                    setTempCreateTimeFrom(null);
                                    history.push({ search: "" });
                                }
                                updateUrlWithFilters();
                            } }),
                        React.createElement(RecekSelect, { id: "entity-type", labelId: "ui-br-users.auditLogs.select.label.entityType", value: tempEntity !== null && tempEntity !== void 0 ? tempEntity : undefined, onChange: function (e) {
                                var newEntity = e.target.value || null;
                                setTempEntity(newEntity);
                            }, dataOptions: entityTypeOptions }),
                        React.createElement(RecekTextField, { labelId: "ui-br-users.auditLogs.field.label.entityId", showLabel: false, placeholder: formatMessage({
                                id: "ui-br-users.auditLogs.field.label.entityId",
                            }), value: tempId, onChange: function (e) { return setTempId(e.target.value); } }),
                        React.createElement(RecekSelect, { labelId: "ui-br-users.auditLogs.select.label.action", dataOptions: actionOptions, value: tempAction !== null && tempAction !== void 0 ? tempAction : undefined, onChange: function (e) {
                                var newAction = e.target.value || null;
                                setTempAction(newAction); // Update temporary state
                            } }),
                        React.createElement(RecekSelection, { labelId: "ui-br-users.auditLogs.selection.label.user", name: "userSelection", value: selectedUser, loading: userLoading, onChange: handleUserSelection, asyncFilter: true, onFilter: handleUserInput, dataOptions: (userOptions !== null && userOptions !== void 0 ? userOptions : []).map(function (user) { return ({
                                value: user.id,
                                label: "".concat(user.firstName, " ").concat(user.lastName),
                            }); }) }),
                        React.createElement(PickerHint, { truncated: usersTruncated }),
                        React.createElement(Row, { style: { margin: "0px" } },
                            React.createElement(Col, null,
                                React.createElement(RecekDatepicker, { labelId: "ui-br-users.auditLogs.label.date", value: tempCreateDateFrom || "", onChange: function (e, formatted, dateString) {
                                        return setTempCreateDateFrom(dateString || null);
                                    }, fullWidth: true, backendDateStandard: "YYYY-MM-DD", dateFormat: "DD.MM.YYYY" })),
                            React.createElement(Col, { style: { marginLeft: "5px" } },
                                React.createElement(RecekTextField, { labelId: "ui-br-users.auditLogs.label.time", placeholder: "HH:MM", value: tempCreateTimeFrom || "", onChange: function (e) { return setTempCreateTimeFrom(e.target.value); }, error: tempCreateTimeFrom &&
                                        !/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(tempCreateTimeFrom)
                                        ? formatMessage({
                                            id: "ui-br-users.auditLogs.error.invalidTimeFormat",
                                        })
                                        : undefined }))),
                        React.createElement(Button, { type: "submit", marginBottom0: true }, "Aplikovat")))))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: filterPaneIsVisible ? "fill" : "100%", paneTitle: formatMessage({
                id: "ui-br-users.auditLogsList.pane.title.auditProtocols",
            }), paneSub: isDefaultWindowApplied(filters)
                ? "".concat(formatAuditRecordCount(totalRecords, totalRecordsExact, formatMessage), " \u2013 ").concat(formatMessage({ id: "ui-br-users.auditLogs.defaultWindowHint" }, { days: AUDIT_DEFAULT_WINDOW_DAYS }))
                : formatAuditRecordCount(totalRecords, totalRecordsExact, formatMessage) },
            React.createElement(TableComponent, { data: auditLogsData, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: totalRecords, pagingOffset: pageOffset, onNeedMoreData: setPageOffset, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source })),
        selectedAuditLog && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: "Audit Log Detail", onClose: function () {
                setSelectedAuditLog(null);
            }, dismissible: true },
            React.createElement(AuditLogDetail, { auditLog: selectedAuditLog })))));
};
export default AuditLogsList;
